import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header.jsx";
import Biography from "./components/bio.jsx";
import Clubs from "./components/club.jsx";
import Gallery from "./components/gallery.jsx";
import Hero from "./components/Hero.jsx";
import Award from "./components/Award.jsx";
import Trophy from "./components/Trophy.jsx";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/earlYears" element={<Biography />} />
          <Route path="/career" element={<Clubs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/awards" element={<Award />} />
          <Route path="/trophies" element={<Trophy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
